export default __webpack_public_path__ + "static/media/swapup.3908437a.svg";